import { DOCUMENT } from '@angular/common';
import { Inject, Injectable } from '@angular/core';

@Injectable()
export class BehaviorTrackerScriptInjectorService {
    public constructor(@Inject(DOCUMENT) private doc: Document) {
    }

    public injectScript(src: string, id?: string): void {
        if (id && this.doc.getElementById(id)) {
            return;
        }

        const script = this.doc.createElement('script');
        script.src = src;
        script.async = true;
        if (id) {
            script.id = id;
        }

        this.doc.head.appendChild(script);
    }

    public injectNoScriptIframe(src: string): void {
        const noscript = this.doc.createElement('noscript');
        noscript.innerHTML = `<iframe src="${ src }" height="0" width="0" style="display:none;visibility:hidden"></iframe>`;
        this.doc.body.appendChild(noscript);
    }
}
